import { render, staticRenderFns } from "./dialogTest.vue?vue&type=template&id=45086262&"
import script from "./dialogTest.vue?vue&type=script&lang=js&"
export * from "./dialogTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "dialogTest.vue"
export default component.exports